// Нэвтрэх (Tomujin DS, "A — Centered photo hero"): бүтэн дэлгэцийн зураг + бараан давхарга, цагаан лого,
// "ДОТООД СИСТЕМ" + бичигдэж буй гарчиг ("Амьдралын / Шинэ үеийн … БОЛОВСРОЛ."), голд цагаан нэвтрэх карт.
// Нэвтэрсний дараа "/" — modules/core-ийн Shell рольоор нь чиглүүлнэ (багш → /t, зөвлөх → /c, олон роль → /choose).
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { AuthContext } from "contexts";
import { instance } from "utils/axios";
import bg from "assets/images/login-bg.jpg";
import logoWhite from "assets/images/logo-white.png";

const WORDS = ["Амьдралын", "Шинэ үеийн", "Цаглашгүй", "Насан туршийн", "Хүнлэг", "Хүүхэд бүрд зориулсан"];
const ACCENT = "#f2cd30";

// Үг бичигдэж, арилж солигдоно; "хөдөлгөөн багасгах" тохиргоотой бол 2.2с тутам шууд солигдоно
function useTyped() {
  const [typed, setTyped] = useState(WORDS[0]);
  useEffect(() => {
    let alive = true;
    let t;
    let w = 0;
    let c = WORDS[0].length;
    let del = true;
    let reduce = false;
    try { reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) { /* noop */ }
    if (reduce) {
      const iv = setInterval(() => { w = (w + 1) % WORDS.length; setTyped(WORDS[w]); }, 2200);
      return () => clearInterval(iv);
    }
    const tick = () => {
      if (!alive) return;
      let delay;
      if (del) {
        c -= 1;
        if (c <= 0) { c = 0; del = false; w = (w + 1) % WORDS.length; delay = 220; } else delay = 28;
      } else {
        c += 1;
        if (c >= WORDS[w].length) { del = true; delay = 1500; } else delay = 55;
      }
      setTyped(WORDS[w].slice(0, c));
      t = setTimeout(tick, delay);
    };
    t = setTimeout(tick, 1500);
    return () => { alive = false; clearTimeout(t); };
  }, []);
  return typed;
}

const Eye = ({ off }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {off ? <>
      <path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" /><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" />
      <path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" /><path d="m2 2 20 20" />
    </> : <><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" /><circle cx="12" cy="12" r="3" /></>}
  </svg>
);

const inputCls = (bad) => `w-full h-12 md:h-11 px-3 text-base rounded-[10px] border bg-white text-[#1c1c1c] outline-none transition focus:ring-2 ${bad ? "border-[#dc2626] focus:ring-red-200" : "border-[#e5d8f5] focus:border-[#5c1090] focus:ring-[#efe6f7]"}`;

const Login = () => {
  const authContext = React.useContext(AuthContext);
  const navigate = useNavigate();
  const typed = useTyped();
  const [f, setF] = useState({ email: "", password: "" });
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (authContext.state.token) navigate("/", { replace: true });
  }, [authContext.state]); // eslint-disable-line react-hooks/exhaustive-deps

  const submit = (e) => {
    e.preventDefault();
    if (!f.email.trim() || !f.password) return setErr("Нэвтрэх нэр, нууц үгээ оруулна уу");
    setLoading(true);
    instance({ method: "post", url: "/login", data: { email: f.email.trim(), password: f.password }, noMessage: false, silent: true })
      .then((res) => authContext.action.login(res.data.token, res.data))
      .catch((er) => {
        // silent: axios-ийн ерөнхий алдааны toast-гүй — алдааг талбарын доор харуулна. API алдааг value / error гэж 2 янзаар буцаадаг; сервер унтарсан үед response огт байхгүй
        const d = er?.response?.data;
        setErr(Array.isArray(d?.value) ? d.value[0]?.msg : d?.value || d?.error || er?.message || "Нэвтэрч чадсангүй");
      })
      .then(() => setLoading(false));
  };
  const set = (k) => (e) => { setF({ ...f, [k]: e.target.value }); setErr(null); };
  const forgot = (e) => { e.preventDefault(); message.info("Нууц үгээ сэргээхийн тулд сургуулийн админд хандана уу."); };

  return (
    <div className="min-h-screen relative overflow-hidden flex flex-col bg-[#1c1c1c] text-[#1c1c1c]" style={{ fontFamily: "Raleway, Roboto, sans-serif" }}>
      <style>{"@keyframes tjCaret{0%,49%{opacity:1}50%,100%{opacity:0}}@media (prefers-reduced-motion: reduce){.tj-caret{animation:none!important}}"}</style>
      <img src={bg} alt="" className="absolute inset-0 w-full h-full object-cover" style={{ objectPosition: "center 70%" }} />
      <div aria-hidden="true" className="absolute inset-0" style={{ background: "rgba(0,0,0,0.45)" }} />

      <header className="relative flex justify-center pt-10 px-5 md:px-6">
        <img src={logoWhite} alt="Tomujin" className="block w-auto h-6 md:h-9" />
      </header>

      <main className="relative flex-1 w-full box-border px-5 md:px-6 py-6 md:py-10 flex flex-col items-center justify-center gap-7 md:gap-9">
        <div className="flex flex-col items-center gap-3 md:gap-4 w-full">
          <p className="m-0 text-xs font-bold uppercase" style={{ letterSpacing: "0.12em", color: ACCENT }}>ДОТООД СИСТЕМ</p>
          <h1 aria-label="Амьдралын боловсрол." className="m-0 w-full text-center font-extrabold uppercase text-white text-[40px] md:text-[clamp(2.5rem,5.4vw,5rem)]" style={{ lineHeight: 0.98, letterSpacing: "-0.02em" }}>
            <span aria-hidden="true" className="flex flex-col justify-end min-h-[1.96em] md:block md:min-h-[0.98em]">
              <span>{"\u200b"}{typed}<span className="tj-caret" style={{ display: "inline-block", width: "0.07em", height: "0.8em", marginLeft: "0.06em", verticalAlign: "-0.04em", background: "#fff", animation: "tjCaret 0.9s steps(1) infinite" }} /></span>
            </span>
            <span aria-hidden="true" className="block" style={{ color: ACCENT }}>боловсрол.</span>
          </h1>
        </div>

        <div className="w-full max-w-[440px] box-border p-6 md:p-8 bg-white rounded-2xl" style={{ boxShadow: "0 20px 25px -5px rgba(0,0,0,0.25), 0 8px 10px -6px rgba(0,0,0,0.2)" }}>
          <form onSubmit={submit} noValidate className="flex flex-col gap-[18px] md:gap-5">
            <div className="flex flex-col gap-2">
              <label htmlFor="login-user" className="text-sm font-semibold text-[#1c1c1c]">Нэвтрэх нэр</label>
              <input id="login-user" name="username" autoComplete="username" placeholder="Жишээ: bat.erdene" value={f.email} onChange={set("email")} className={inputCls(err && !f.email)} autoFocus />
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex justify-between items-baseline gap-3">
                <label htmlFor="login-pass" className="text-sm font-semibold text-[#1c1c1c]">Нууц үг</label>
                <a href="#forgot" onClick={forgot} className="hidden md:inline text-sm font-semibold !text-[#5c1090] hover:!text-[#3d1b6e]">Нууц үгээ мартсан уу?</a>
              </div>
              <div className="relative">
                <input id="login-pass" name="password" type={showPw ? "text" : "password"} autoComplete="current-password" placeholder="••••••••" value={f.password} onChange={set("password")} className={`${inputCls(!!err)} pr-12`} aria-invalid={!!err} aria-describedby={err ? "login-err" : undefined} />
                <button type="button" onClick={() => setShowPw(!showPw)} aria-label={showPw ? "Нууц үгийг нуух" : "Нууц үгийг харуулах"} aria-pressed={showPw}
                  className="absolute top-0.5 right-0.5 md:top-0 md:right-0 w-11 h-11 flex items-center justify-center bg-transparent border-0 rounded-[10px] text-[#6e5e8a] cursor-pointer">
                  <Eye off={showPw} />
                </button>
              </div>
              {err && <span id="login-err" role="alert" className="text-sm text-[#dc2626]">{err}</span>}
            </div>
            <button type="submit" disabled={loading} className="w-full h-12 rounded-[10px] border-0 text-base font-bold cursor-pointer disabled:opacity-60 hover:brightness-95 transition" style={{ background: ACCENT, color: "#1c1c1c" }}>
              {loading ? "Нэвтэрч байна…" : "Нэвтрэх"}
            </button>
            <a href="#forgot" onClick={forgot} className="md:hidden self-center min-h-[44px] flex items-center text-sm font-semibold !text-[#5c1090]">Нууц үгээ мартсан уу?</a>
          </form>
        </div>
      </main>

      <footer className="relative px-6 pt-4 pb-6 text-center text-xs text-white" style={{ lineHeight: 1.33 }}>© {new Date().getFullYear()} Томүжин Алтернатив Сургууль</footer>
    </div>
  );
};

export default Login;
